export default "__VITE_ASSET__D7XAm7Gz__"